<template>
  <Tag
    :class="tag_classes"
    rounded
  >
    <AppIcon
      v-if="icon"
      :name="icon"
    />
    <span
      v-if="$slots.default"
      :class="{ truncate: truncate }"
    >
      <slot />
    </span>
  </Tag>
</template>

<script setup>
import { computed } from 'vue';
import { STATUS, STATUS_COLORS } from '@/app/data/status_constants';
import { SIZE_CLASSES_TAG as SIZE_CLASSES } from '@/app/shared_components/tags/tag_constants';

const props = defineProps({
  color: {
    type: String,
    default: STATUS.DEFAULT,
    validator: (value) => Object.values(STATUS).includes(value),
  },
  icon: { type: String, default: null },
  size: {
    type: String,
    default: 'small',
    validator: (value) => Object.keys(SIZE_CLASSES).includes(value),
  },
  truncate: { type: Boolean },
});

const tag_classes = computed(() => {
  const theme = STATUS_COLORS[props.color];
  return [
    'inline-flex items-center gap-1 rounded-full text-xs! shrink-0 ',
    theme.TAG_BG,
    theme.TAG_TEXT,
    SIZE_CLASSES[props.size],
  ];
});
</script>
